import {MenuItem, Select} from "@mui/material";
import {
    Termination,
    TerminationField,
    TerminationItem,
    TerminationItemField,
} from "../../../../app/api/model/termination";
import {TranslationContext, getTranslation} from "../../../../utils/getTranslationKey";
import {useTranslation} from "react-i18next";
import {useTerminationItemUpdateMutation} from "../../../../app/api/api";
import {useSnackbar} from "notistack";

export interface TerminationItemEnumSelectProps {
    terminationId: Termination[TerminationField.ID];
    item: TerminationItem;
    field: TerminationItemField.RETURN_STATUS | TerminationItemField.TEST_RESULT;
    context: TranslationContext;
    options: string[];
    isReadonly?: boolean;
}

export function TerminationItemEnumSelect({
    terminationId,
    item,
    field,
    context,
    options,
    isReadonly,
}: Readonly<TerminationItemEnumSelectProps>) {
    const {t} = useTranslation();
    const [updateTerminationItem] = useTerminationItemUpdateMutation();
    const {enqueueSnackbar} = useSnackbar();

    const handleValueChanged = (value: string) => {
        updateTerminationItem({
            [TerminationItemField.ID]: item[TerminationItemField.ID],
            [TerminationItemField.TERMINATION_ID]: terminationId,
            item: {[field]: value},
        })
            .unwrap()
            .then(() => {
                enqueueSnackbar(t("generic_success"), {variant: "success"});
            });
    };

    return isReadonly ? (
        <>
            {getTranslation({
                context,
                value: item[field],
                t,
            })}
        </>
    ) : (
        <Select
            value={item[field]}
            onChange={(evt) => handleValueChanged(evt.target.value)}
            size="small"
            sx={{width: 200}}
        >
            {options.map((o) => (
                <MenuItem key={o} value={o}>
                    {getTranslation({context, value: o, t})}
                </MenuItem>
            ))}
        </Select>
    );
}
